import PageHeader from "@/components/PageHeader";
import { Instagram, ArrowUpRight, MessageCircle, HandHelping, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const ContactPage = () => {
  return (
    <>
      <PageHeader
        overline="Say Hello"
        title="Let's"
        accent="Talk."
        subtitle="Questions, ideas, or just want to say hey — the fastest way to reach us is Instagram."
        testId="contact-header"
      />

      <section className="relative pb-24 md:pb-32" data-testid="contact-section">
        <div className="glow-green top-20 -left-40 opacity-40" />
        <div className="glow-blue bottom-20 -right-40 opacity-40" />

        <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
          {/* Massive Instagram handle */}
          <div className="mb-16 md:mb-24" data-testid="contact-instagram-hero">
            <p className="overline mb-4">Best Way To Connect</p>
            <h2 className="font-heading font-black text-4xl md:text-6xl uppercase tracking-tight mb-4">
              Follow us on
            </h2>
            <a
              href="https://instagram.com/rvastudents"
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-baseline gap-3 md:gap-5 flex-wrap"
              data-testid="contact-instagram-link"
            >
              <span className="font-heading font-black text-6xl sm:text-7xl md:text-8xl lg:text-9xl uppercase tracking-tight text-forest-glow text-glow-green leading-none">
                @rvastudents
              </span>
              <ArrowUpRight
                size={60}
                className="text-forest-glow group-hover:rotate-45 transition-transform"
              />
            </a>
            <p className="mt-8 text-white/60 text-lg md:text-xl leading-relaxed max-w-2xl">
              Gathering details, address drops, photos, and everything else lives on Instagram.
              <span className="text-white font-semibold"> DMs are open</span> — slide in with any
              question.
            </p>
          </div>

          <div className="hr-line mb-16" />

          {/* Three-card grid */}
          <div className="grid md:grid-cols-3 gap-4">
            <a
              href="https://instagram.com/rvastudents"
              target="_blank"
              rel="noreferrer"
              className="card-glass p-8 md:p-10 group flex flex-col justify-between"
              data-testid="contact-dm-card"
            >
              <div>
                <div className="w-12 h-12 rounded-2xl border border-white/10 flex items-center justify-center mb-8 text-forest-glow">
                  <MessageCircle size={20} />
                </div>
                <p className="overline mb-3">DM Us</p>
                <p className="font-heading font-black text-2xl md:text-3xl uppercase tracking-tight leading-tight">
                  Message us on<br />
                  <span className="text-forest-glow">Instagram</span>
                </p>
                <p className="mt-4 text-white/60 text-sm">
                  Fastest reply. Ask anything.
                </p>
              </div>
              <div className="flex items-center justify-between mt-8">
                <span className="text-sm font-heading uppercase tracking-widest text-white/60">@rvastudents</span>
                <Instagram size={22} className="shrink-0 group-hover:scale-110 transition-transform" />
              </div>
            </a>

            <a
              href="mailto:studentsofrva@gmail.com"
              className="card-glass p-8 md:p-10 group flex flex-col justify-between"
              data-testid="contact-email-card"
            >
              <div>
                <div className="w-12 h-12 rounded-2xl border border-white/10 flex items-center justify-center mb-8 text-deepblue-glow">
                  <Mail size={20} />
                </div>
                <p className="overline mb-3">Email</p>
                <p className="font-heading font-black text-2xl md:text-3xl uppercase tracking-tight leading-tight">
                  Send us<br />
                  <span className="text-deepblue-glow">an email</span>
                </p>
                <p className="mt-4 text-white/60 text-sm">
                  For the longer conversations.
                </p>
              </div>
              <div className="flex items-center justify-between mt-8">
                <span className="text-sm font-heading uppercase tracking-widest text-white/60 break-all">studentsofrva@gmail.com</span>
                <ArrowUpRight size={22} className="shrink-0 group-hover:rotate-45 transition-transform" />
              </div>
            </a>

            <Link
              to="/get-involved"
              className="card-glass p-8 md:p-10 group flex flex-col justify-between"
              data-testid="contact-involved-card"
            >
              <div>
                <div className="w-12 h-12 rounded-2xl border border-white/10 flex items-center justify-center mb-8 text-forest-glow">
                  <HandHelping size={20} />
                </div>
                <p className="overline mb-3">Want To Help?</p>
                <p className="font-heading font-black text-2xl md:text-3xl uppercase tracking-tight leading-tight">
                  Fill out the<br />
                  <span className="text-forest-glow">Get Involved</span> form
                </p>
                <p className="mt-4 text-white/60 text-sm">
                  Serve, lead, or stay in the loop.
                </p>
              </div>
              <div className="flex items-center justify-between mt-8">
                <span className="text-sm font-heading uppercase tracking-widest text-white/60">Start Here</span>
                <ArrowUpRight
                  size={22}
                  className="shrink-0 group-hover:rotate-45 transition-transform"
                />
              </div>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
